<template>
  <v-container>
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />
    <v-form ref="generalSheetForm" v-model="generalSheetValid">
      <v-row no-gutters>
        <v-col>
          <v-card-title
            >{{ $store.getters.getTextMap().manufacturing_logbooks }}
            {{ $store.getters.getTextMap().status }}
            {{ $store.getters.getTextMap().sheet }}</v-card-title
          >
        </v-col>
      </v-row>
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :color="'transparent'"
        elevation="4"
        class="my-2"
        style="
          padding: 15px 15px 15px 15px;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <v-row>
          <v-col>
            <v-text-field
              v-if="!loading"
              v-model="form.name"
              :rules="nameRules"
              :label="$store.getters.getTextMap().sheet_name"
              dense
              outlined
              required
              :dark="$store.getters.getColorPalette().isDark"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-select
              v-if="!loading"
              v-model="form.meta.timeframe"
              :items="timeframeOptions"
              :label="$store.getters.getTextMap().time_frame"
              dense
              outlined
              item-text="label"
              item-value="value"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              required
              :dark="$store.getters.getColorPalette().isDark"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              v-if="!loading"
              v-model="form.meta.timestamp_type"
              :items="timestampTypeOptions"
              :label="
                $store.getters.getTextMap().timestamp +
                ' ' +
                $store.getters.getTextMap().type
              "
              dense
              outlined
              item-text="label"
              item-value="value"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              required
              :dark="$store.getters.getColorPalette().isDark"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-if="!loading"
              v-model="status_list"
              :items="statusOptions"
              :label="$store.getters.getTextMap().status"
              dense
              outlined
              multiple
              item-text="label"
              item-value="value"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              required
              :dark="$store.getters.getColorPalette().isDark"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              v-if="!loading"
              v-model="stage_list"
              :items="stageOptions"
              :label="$store.getters.getTextMap().stage"
              dense
              outlined
              multiple
              item-text="label"
              item-value="value"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              required
              :dark="$store.getters.getColorPalette().isDark"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              v-if="!loading"
              v-model="column_list"
              :items="columnsOptions"
              :label="$store.getters.getTextMap().column"
              dense
              outlined
              multiple
              item-text="label"
              item-value="value"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              required
              :dark="$store.getters.getColorPalette().isDark"
            ></v-select>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :color="'transparent'"
        elevation="4"
        class="my-2"
        style="
          padding: 15px 15px 15px 15px;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <v-row>
          <v-col cols="auto" class="d-flex">
            <v-col>
              <v-checkbox
                :label="
                  $store.getters.getTextMap().add +
                  ' ' +
                  $store.getters.getTextMap().all
                "
                v-model="addAllLogbook"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-select
                :dark="$store.getters.getColorPalette().isDark"
                :color="$store.getters.getColorPalette().inputtextColor"
                v-if="!loading"
                v-model="logbook_id"
                outlined
                :items="logbookOptions"
                :label="$store.getters.getTextMap().log_book"
                dense
                filled
                item-text="label"
                item-value="value"
                :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              ></v-select>
            </v-col>
            <v-btn
              class="mt-4 mx-5"
              color="gray darken-1"
              small
              outlined
              @click="addLogbookToList"
              >{{ $store.getters.getTextMap().add_to_list }}</v-btn
            >
            <v-btn
              class="mt-4 mx-5"
              :color="$store.getters.getColorPalette().deletebtnColor"
              outlined
              small
              @click="deleteFromLogbookTable"
              >{{ $store.getters.getTextMap().cancel }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card
              :dark="$store.getters.getColorPalette().isDark"
              :color="'transparent'"
              flat
            >
              <v-row
                v-if="!loading && logbookTableDetails"
                style="margin-top: 20px"
              >
                <v-col cols="12">
                  <v-simple-table
                    height="200px"
                    :style="{ background: 'transparent' }"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            <strong>{{
                              $store.getters.getTextMap().name
                            }}</strong>
                          </th>
                          <th class="text-left">
                            <strong>{{
                              $store.getters.getTextMap().check_list
                            }}</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr :key="item" v-for="item in logbookTableDetails">
                          <td>{{ getLogbookNameById(item) }}</td>
                          <td>{{ item }}</td>
                          <td>
                            <DeleteConfirmation
                              v-on:confirm="deleteFromLogbookTable(item)"
                              title="Delete Confirmation"
                              description="Are you sure you want to delete this?"
                            >
                              <v-icon
                                small
                                :color="
                                  $store.getters.getColorPalette()
                                    .deletebtnColor
                                "
                                >mdi-delete</v-icon
                              >
                            </DeleteConfirmation>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col align="right">
          <v-skeleton-loader
            v-if="loading"
            class="mx-auto"
            type="text"
          ></v-skeleton-loader>
          <v-btn
            v-if="!loading"
            :color="$store.getters.getColorPalette().submitbtnColor"
            small
            @click="sheetSubmit"
            >{{ $store.getters.getTextMap().submit }}</v-btn
          >
        </v-col>
        <v-col align="left">
          <v-skeleton-loader
            v-if="loading"
            class="mx-auto"
            type="text"
          ></v-skeleton-loader>
          <v-btn
            v-if="!loading"
            :color="$store.getters.getColorPalette().cancelbtnColor"
            :dark="$store.getters.getColorPalette().isDark"
            outlined
            small
            @click="close"
            >{{ $store.getters.getTextMap().cancel }}</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import InfoAlert from "@/components/InfoAlert";
import DeleteConfirmation from "@/components/DeleteConfirmation";
import axios from "axios";
export default {
  name: "ManufacturingLogbookStatusSheet",
  props: {
    sheet: {
      type: Object,
    },
  },
  components: {
    InfoAlert,
    DeleteConfirmation,
  },
  mounted() {
    if (this.sheet && this.sheet.meta) {
      this.logbookTableDetails = this.sheet.meta.logbooks;
      this.form.name = this.sheet.name;
      this.api = "updateSheets";
      this.form.sheet_id = this.sheet.sheet_id;
      this.form.meta.dataSource = this.sheet.meta.dataSource;
      this.status_list = this.sheet.meta.status_list
        ? this.sheet.meta.status_list
        : [];
      this.stage_list = this.sheet.meta.stage_list
        ? this.sheet.meta.stage_list
        : [];
      this.column_list = this.sheet.meta.column_list
        ? this.sheet.meta.column_list
        : [];
    }
    // console.log(this.sheet.meta.column_list);
    this.getManufacturingLogbookOptions();
    this.form.sheet_type = "manufacturingLogbookStatusSheet";
  },
  data() {
    return {
      showDialog: false,
      api: "createSheets",
      logbookTableDetails: [],
      logbook_id: null,
      logbookOptions: [],
      status_list: [],
      stage_list: [],
      column_list: [],
      generalSheetValid: false,
      showDismissibleAlert: false,
      loading: false,
      addAllLogbook: false,
      info: "",
      dbData: [],
      timeframeOptions: [
        { label: "MTD", value: "mtd" },
        { label: "Yesterday", value: "yesterday" },
        { label: "Last 7 Days", value: "last7" },
      ],
      timestampTypeOptions: [
        { label: "Created At", value: "timestamp" },
        { label: "Submitted At", value: "submitted_timestamp" },
      ],
      statusOptions: [
        { label: "In Process", value: "in_process" },
        { label: "Completed", value: "completed" },
        { label: "Rejected", value: "rejected" },
        { label: "Refill", value: "refill" },
      ],
      stageOptions: [
        { label: "Maker", value: "maker" },
        { label: "Approver", value: "approver" },
        { label: "Checker", value: "checker" },
        // { label: "Issuer", value: "issuer" },
      ],
      columnsOptions: [
        { label: "Name", value: `name` },
        { label: "Logbook ID", value: `logbook_id` },
        { label: "Stage", value: `stage` },
        { label: "Status", value: `status` },
        {
          label: "Auto Submitted",
          value: `auto_submitted`,
        },
        { label: "Submitted By", value: `submitted_by` },
        { label: "Refilled By", value: `refilled_by` },
        { label: "Approved By", value: `approved_by` },
        { label: "Checked By", value: `checked_by` },
        {
          label: "Fill Started (Boolean)",
          value: `fill_started`,
        },
        {
          label: "Fill Started By",
          value: `fill_started_by`,
        },
        {
          label: "Approver's Remark",
          value: `approver_remarks`,
        },
        {
          label: "Checker's Remark",
          value: `checker_remarks`,
        },
      ],

      form: {
        name: null,
        sheet_type: "manufacturingLogbookStatusSheet",
        meta: {
          logbooks: [],
          timeframe: "last7",
          timestamp_type: "timestamp",
        },
      },
      objectRules: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => /\S+/.test(v) || "Name is required",
        (v) =>
          (v && v.length <= 100 && v.length > 0) ||
          "Name must be less than 100 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+,?/.test(v) || "E-mail must be valid",
      ],
      numberRules: [
        (v) => !!v || "Required",
        (v) => /[0-9]+$/.test(v) || "It should be a number",
        (v) => (v && v >= 0 && v % 1 == 0) || "It should be a valid number",
        (v) =>
          (v && v.length <= 5 && v.length > 0) ||
          "Name must be less than 6 digits",
      ],
      nonNegativeRules: [
        (v) => !!v || "Required",
        (v) => /[0-9]+$/.test(v) || "It should be a number",
        (v) => (v && v > 0 && v % 1 == 0) || "It should be a valid number",
        (v) =>
          (v && v.length <= 5 && v.length > 0) ||
          "Name must be less than 6 digits",
      ],
    };
  },
  methods: {
    getLogbookNameById(id) {
      let details = this.dbData.find((item) => item.logbook_id === id);
      return details && details.name ? details.name : id;
    },
    getManufacturingLogbookOptions() {
      let op = [];
      this.loading = true;
      axios
        .get(this.$store.state.api + "manufacturing_logbooks", {
          headers: { Authorization: "Bearer " + this.$store.state.jwt },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.dbData = response.data.data;
            for (let i of this.dbData) {
              if (i && i.name) {
                op.push({ value: i.logbook_id, label: i.name });
              } else {
                op.push({ value: i.logbook_id, label: i.name });
              }
            }
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.info = err;
          this.showDismissibleAlert = true;
        });
      this.logbookOptions = op;
    },
    close() {
      this.$emit("close");
    },
    addLogbookToList() {
      if (!this.logbookTableDetails) {
        this.logbookTableDetails = [];
      }
      if (this.logbook_id) {
        this.logbookTableDetails.push(this.logbook_id);
      } else {
        this.loading = false;
        this.info = "Please select logbook";
        this.showDismissibleAlert = true;
      }
      this.logbook_id = null;
    },
    sheetSubmit() {
      this.$refs.generalSheetForm.validate();
      if (
        this.generalSheetValid &&
        this.logbookTableDetails &&
        this.logbookTableDetails.length > 0
      ) {
        this.loading = true;
        this.form.meta.logbooks = this.logbookTableDetails;
        let d = Object.assign({}, this.form);
        if (this.status_list && this.status_list.length > 0) {
          d.meta.status_list = this.status_list;
        }
        if (this.stage_list && this.stage_list.length > 0) {
          d.meta.stage_list = this.stage_list;
        }
        if (this.column_list && this.column_list.length > 0) {
          d.meta.column_list = this.column_list;
        }
        axios
          .post(this.$store.state.api + this.api, d, {
            headers: {
              Authorization: "Bearer " + this.$store.state.jwt,
            },
          })
          .then((response) => {
            if (response.data.status == "success") {
              this.loading = false;
              this.$emit("update");
              this.$store.dispatch("refreshSheets");
              this.$refs.generalSheetForm.reset();
              this.close();
            } else {
              this.loading = false;
              this.info = response.data.msg;
              this.showDismissibleAlert = true;
            }
          })
          .catch((err) => {
            this.loading = false;
            this.info = err;
            this.showDismissibleAlert = true;
          });
      } else {
        this.loading = false;
        this.info = "Please add logbook";
        this.showDismissibleAlert = true;
      }
    },
    addAllLogbookToList() {
      for (let i of this.dbData) {
        this.logbookTableDetails.push(i.logbook_id);
      }
    },
    removeAllLogbookFromList() {
      this.logbookTableDetails = [];
    },
    deleteFromLogbookTable(item) {
      this.logbookTableDetails = this.logbookTableDetails.filter(
        (x) => x != item
      );
    },
    onLogbookReset() {
      this.logbook_id = null;
      this.loading = false;
    },
    cancel() {
      this.showDialog = false;
    },
    confirm() {
      this.showDialog = false;
    },
  },
  watch: {
    addAllLogbook() {
      if (this.addAllLogbook) {
        this.addAllLogbookToList();
      } else {
        this.removeAllLogbookFromList();
      }
    },
  },
};
</script>
